import eventsHandler from '@/services/common/eventsHandler.js'

class absenceTypesForm extends eventsHandler {
  constructor() {
    super()
    this._absenceType = {}
    this._valid = false
  }

  get absenceType() {
    const absenceType = {
      ...this._absenceType
    }
    return absenceType
  }

  get valid() {
    return this._valid
  }

  get isNew() {
    return !this._absenceType.id
  }

  setValid(valid) {
    this._valid = valid
    this._executeCallbacksOf('valid-change', valid)
  }

  resetAbsenceType() {
    this._absenceType = {}
    this._executeCallbacksOf('reset')
    this._executeCallbacksOf('update', {absenceType: {}})
  }

  updateField(key, value) {
    this._absenceType[key] = value
    this._executeCallbacksOf('update', {absenceType: this._absenceType})
    this._executeCallbacksOf('update-' + key, {key: this._absenceType[key]})
    this._executeCallbacksOf('update-is-new', this.isNew)
  }

  updateObject(absenceType) {
    this._absenceType = absenceType
    this._executeCallbacksOf('update', {absenceType: this._absenceType})
    this._executeCallbacksOf('update-is-new', this.isNew)
  }
}

export default new absenceTypesForm()